module.exports = __webpack_public_path__ + "img/6.4b4a68cc.png";